import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authService';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await login(email, password);

        if (result.ok) {
            // Fetch user data to determine if admin or customer
            const userData = await authService.me();

            if (userData?.is_admin) {
                // Admin users go to unified dashboard
                navigate('/unified-dashboard');
            } else {
                // Regular users (customers) go to customer dashboard
                navigate('/customer-dashboard');
            }
        } else {
            setError('Invalid credentials. Please try again.');
        }

        setLoading(false);
    };

    return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#0c0c0c', color: '#ffffe3' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-sm-10 col-md-6 col-lg-4">
                        <div className="card shadow-lg border-0" style={{ backgroundColor: 'transparent' }}>
                            <div className="card-body p-4 border border-secondary rounded">
                                <h3 className="mb-4 text-center" style={{ fontFamily: 'Satoshi, sans-serif', fontWeight: 700, color: '#ffffe3' }}>Sign in</h3>

                                {error && (
                                    <div className="alert alert-danger" role="alert" style={{ backgroundColor: 'rgba(220, 53, 69, 0.1)', borderColor: '#dc3545', color: '#ffffe3' }}>
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label" style={{ color: '#ffffe3' }}>Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            autoComplete="email"
                                            required
                                            disabled={loading}
                                            style={{ backgroundColor: 'transparent', borderColor: 'rgba(255, 255, 227, 0.15)', color: '#ffffe3', borderRadius: '0' }}
                                        />
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label" style={{ color: '#ffffe3' }}>Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            autoComplete="current-password"
                                            required
                                            disabled={loading}
                                            style={{ backgroundColor: 'transparent', borderColor: 'rgba(255, 255, 227, 0.15)', color: '#ffffe3', borderRadius: '0' }}
                                        />
                                    </div>

                                    <button
                                        className="btn w-100"
                                        type="submit"
                                        disabled={loading}
                                        style={{ backgroundColor: '#ffffe3', color: '#0c0c0c', borderRadius: '50px', fontWeight: 500, padding: '10px 0' }}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Logging in...
                                            </>
                                        ) : (
                                            'Login'
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>

                        <p className="text-center mt-4">
                            <a href="/" style={{ color: '#ffffe3', textDecoration: 'none' }}>← Back to site</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;

